var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTabArrowBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_259_776)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.51924 15.6686L15.3762 0.811792C15.4836 0.575226 15.4196 0.292947 15.2162 0.12838C15.0128 -0.0373304 14.7237 -0.0430445 14.5145 0.114666L8.00039 5.00026L1.48627 0.114666C1.27713 -0.0430445 0.986853 -0.0373304 0.784573 0.127237C0.64629 0.238091 0.572006 0.403802 0.572006 0.571797C0.572006 0.652938 0.589149 0.734079 0.624576 0.810649L7.48155 15.6674C7.57526 15.8709 7.77754 16 8.00039 16C8.22325 16 8.42553 15.8708 8.51924 15.6686Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_259_776"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "matrix(0 1 -1 0 16 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabArrowBlack);
export default __webpack_public_path__ + "static/media/tab-arrow-black.3231c52bb4e2e168c2226ae3d5fdf776.svg";
export { ForwardRef as ReactComponent };